// component
import RouterView from '@/components/router-view.vue';

import RollOutProjectListCom from './roll-out-project-list/roll-out-project-list.vue';
import RollOutProjectDetailCom from './roll-out-project-detail/roll-out-project-detail.vue';
import HandleRouting from './trans-handle/transaction-handle-routing';

export default [
  {
    path: 'list',
    name: 'rollOutProjectList',
    component: RollOutProjectListCom,
    meta: {
      title: '转出项目',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'rollOutProjectDetail',
    component: RollOutProjectDetailCom,
    meta: {
      title: '项目详情',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'trans',
    component: RouterView,
    redirect: '/person-center/project/roll-out-project/trans',
    meta: {
      title: '处理',
      breadCrumbShowIndexArr: [0, 2]
    },
    children: HandleRouting
  }
];

